import {ROUTES} from "@constants"
import i18n from "@/lang/i18n";

export default [
  {
    path: 'big-category',
    name: ROUTES.ADMIN.BIG_CATEGORY_LIST,
    meta: {
      title: '大カテゴリ一覧',
      breadcrumb: [
        {
          'label': 'breadcrumbs.Big Category List',
        },
      ],
      activeKey: 'admin.big-category.list'
    },
    component: () => import("@pages/admin/qa_chatbots/BigCategoryList"),
  },
  {
    path: 'big-category/create',
    name: ROUTES.ADMIN.BIG_CATEGORY_CREATE,
    meta: {
      title: '大カテゴリ一覧',
      breadcrumb: [
        {
          'label': 'breadcrumbs.Big Category List',
          'href': '/admin/big-category',
        },
        {
          'label': 'breadcrumbs.Big Category Create',
        },
      ],
      activeKey: 'admin.big-category.create'
    },
    component: () => import("@pages/admin/qa_chatbots/BigCategoryCreateOrEdit"),
  },
  {
    path: 'big-category/:id/edit',
    name: ROUTES.ADMIN.BIG_CATEGORY_EDIT,
    meta: {
      title: '大カテゴリ一覧',
      breadcrumb: [
        {
          'label': 'breadcrumbs.Big Category List',
          'href': '/admin/big-category',
        },
        {
          'label': 'breadcrumbs.Big Category Edit',
        },
      ],
      activeKey: 'admin.big-category.edit'
    },
    component: () => import("@pages/admin/qa_chatbots/BigCategoryCreateOrEdit"),
  },
];
